import { Input } from "@ui/input";
import { Label } from "@ui/label";
import { ValidationError } from "@/components/ui/validation-error";
import type { InputHeaderType } from "./types";
import { GridHeaderVisibilityFields } from "./visibility-fields";

export function InputHeaderFields({
    header,
    updateHeader,
    headerError,
}: InputHeaderType) {
    const getDefaultValueText = () => {
        if (!("defaultValue" in header)) return "";
        return (header.defaultValue as string) ?? "";
    };

    return (
        <GridHeaderVisibilityFields header={header} updateHeader={updateHeader}>
            <div>
                <Label>Placeholder</Label>
                <Input
                    value={header.placeholder ?? ""}
                    placeholder="Placeholder"
                    onChange={(e) => updateHeader({ placeholder: e.target.value })}
                />
            </div>
            <div>
                <Label>Default Value</Label>
                <Input
                    type="text"
                    value={getDefaultValueText()}
                    placeholder="Default Value"
                    onChange={(e) => updateHeader({ defaultValue: e.target.value })}
                />
            </div>
            {headerError && <ValidationError>{headerError}</ValidationError>}
        </GridHeaderVisibilityFields>
    );
}
